import { Box, Popover, Text } from '@mantine/core';
import Link from 'next/link';
import { type PropsWithChildren } from 'react';

import { type CoreItemRelatedBundle, type CoreProduct } from '@flecto/types'
import { AvatarProduct, TextProductTitle } from '@flecto/ui'

import { useProductSlugEncode } from '../../hooks/useProductSlugEncode'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import classes from './styles.module.css'

export type PopoverAdditionalBundlesProps = PropsWithChildren & {
  bundles: CoreItemRelatedBundle[]
}

export function PopoverAdditionalBundles({
  bundles,
  children,
}: PopoverAdditionalBundlesProps) {
  return (
    <Popover>
      <Popover.Target>
        <Text className={classes.link} component='span'>
          {children}
        </Text>
      </Popover.Target>
      <Popover.Dropdown miw={280} mah={280} style={{ overflow: 'auto' }}>
        {bundles.map((p) => (
          <RowItem key={p.id} product={p as CoreProduct} />
        ))}
      </Popover.Dropdown>
    </Popover>
  )
}

function RowItem({ product }: { product: CoreProduct }) {
  const path = useStorePathBuilder()
  const slug = useProductSlugEncode(product)
  const link = path(`/products/${slug}`)

  return (
    <Box className={classes.item}>
      <AvatarProduct product={product} />
      <Link href={link}>
        <TextProductTitle product={product} />
      </Link>
    </Box>
  )
}
